import { GraduationCap } from "lucide-react";
import { cursos } from "@/data/landingData";

const CursosSection = () => (
  <section id="cursos" className="py-16 sm:py-24">
    <div className="container mx-auto px-5 sm:px-4">
      <div className="text-center mb-10 sm:mb-16">
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
          <span className="text-gradient-green">Cursos</span> Online
        </h2>
        <p className="text-base sm:text-xl text-muted-foreground max-w-2xl mx-auto">Cursos focados em sua imagem e estilo</p>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-6 max-w-5xl mx-auto">
        {cursos.map((curso, index) => (
          <div
            key={curso.title}
            className={`rounded-3xl p-6 sm:p-8 ${curso.highlight ? "bg-primary text-primary-foreground border-2 border-primary shadow-glow-strong" : "bg-card border border-border/50"}`}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className={`w-14 h-14 rounded-2xl mb-4 flex items-center justify-center ${curso.highlight ? "bg-primary-foreground/20" : "bg-primary/10"}`}>
              <GraduationCap className={`w-7 h-7 ${curso.highlight ? "text-primary-foreground" : "text-primary"}`} />
            </div>
            <h3 className="font-display text-lg sm:text-xl font-bold mb-3">{curso.title}</h3>
            <p className={`mb-6 text-sm sm:text-base ${curso.highlight ? "text-primary-foreground/80" : "text-muted-foreground"}`}>{curso.description}</p>
            <a
              href={curso.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-full py-3 rounded-full font-semibold transition-all hover:scale-105 inline-flex items-center justify-center ${curso.highlight ? "bg-background text-foreground hover:bg-foreground hover:text-background" : "bg-primary text-primary-foreground"}`}
            >
              Saber mais
            </a>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CursosSection;
